module.exports = __webpack_public_path__ + "static/21-b0450a68d17ec67a8dca62aa8b3c5051.png";